"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Info = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var Info = {};
exports.Info = Info;

if (!('Symbol' in global)) {
  Info.globalSybmol = false;
  var SymIndex = 0;

  global.Symbol = function () {
    if (!babelHelpers.instanceof(this, Symbol)) return new Symbol();
    this.__value = "Symbol$".concat(SymIndex++);
  };

  global.Symbol.prototype = babelHelpers.defineProperty({
    valueOf: function valueOf() {
      return this.__value;
    },
    toString: function toString() {
      return this.__value;
    }
  }, '@@toStringTag', 'Symbol');
  ['iterator', 'match', 'prototype', 'replace', 'search', 'species', 'split', 'toPrimitive', 'toStringTag', 'unscopables'].forEach(function (key) {
    global.Symbol[key] = Symbol("Symbol$".concat(key));
  });
  var reg = {};
  reg['react.element'] = 0xeac7; // Hack for react.js: this polyfill might not exist when React wants it later.

  global.Symbol.for = function (key) {
    if (!reg[key]) reg[key] = Symbol();
    return reg[key];
  };

  global.Symbol.keyFor = function (sym) {
    for (var i in reg) {
      if (reg[i] === sym) return i;
    }
  };
} // Object.assign


if (!('assign' in Object)) {
  Object.assign = function (target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    args.forEach(function (object) {
      if (object && babelHelpers.typeof(object) == 'object') Object.keys(object).forEach(function (key) {
        target[key] = object[key];
      });
    });
    return target;
  };

  Info.objectAssign = true;
}

if (!_exports.default.Channel && !('forEach' in NodeList.prototype)) {
  Object.defineProperty(NodeList.prototype, 'forEach', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function forEach(callback, self) {
      for (var i = 0; i < this.length; i++) {
        callback.call(self, this[i]);
      }
    }
  });
  Info.nodeListForEach = true;
}

if (!_exports.default.Channel) {
  var E = document.createElement('div');
  Info.objectFit = 'objectFit' in E.style;
  Info.objectPosition = 'objectPosition' in E.style;

  try {
    E.innerHTML = "<div class='foo'></div>";
    E.querySelector(':scope > .foo');
    Info.scopedSelector = true;
  } catch (err) {
    Element.prototype._baseQuerySelector = Element.prototype.querySelector;
    Element.prototype._baseQuerySelectorAll = Element.prototype.querySelectorAll;

    Element.prototype.querySelector = function (selector) {
      if (/:scope/.test(selector)) {
        return this._doScopedQuery(selector, this._baseQuerySelector);
      }

      return this._baseQuerySelector(selector);
    };

    Element.prototype.querySelectorAll = function (selector) {
      if (/:scope/.test(selector)) {
        return this._doScopedQuery(selector, this._baseQuerySelectorAll);
      }

      return this._baseQuerySelectorAll(selector);
    };

    var cachedTempNode = document.createElement('div');

    Element.prototype._doScopedQuery = function (selector, which) {
      var isCache = false;

      if (!this.parentNode) {
        isCache = true;
        cachedTempNode.appendChild(this);
      }

      selector = selector.replace(/:scope/g, '[data-qsa-root=true]');
      this.dataset.qsaRoot = 'true';
      var r, e;

      try {
        r = which.call(this.parentNode, selector);
      } catch (err) {
        e = err;
      }

      if (isCache) cachedTempNode.removeChild(this);
      delete this.dataset.qsaRoot;
      if (e) throw e;
      return r;
    };

    Info.scopedSelector = false;
  }

  E.style.setProperty('--var', '10px');
  E.style.height = '10px';
  E.style.height = 'var(--var, 10px)';
  if (/--var/.test(E.style.height)) Info.cssVariables = true;

  if (!('remove' in Element)) {
    Info.elementRemove = false;

    Element.prototype.remove = function () {
      this.parentNode.removeChild(this);
    };

    CharacterData.prototype.remove = DocumentType.prototype.remove = Element.prototype.remove;
  } else {
    Info.elementRemove = true;
  }
}